import { render, staticRenderFns } from "./setoptionalfees.vue?vue&type=template&id=20fd20a0&"
import script from "./setoptionalfees.vue?vue&type=script&lang=js&"
export * from "./setoptionalfees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports